import React from 'react';
import {motion} from 'framer-motion';
import {FiExternalLink, FiRefreshCw} from 'react-icons/fi';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import GlowText from '../components/ui/GlowText';

const News = () => {
  return (
    <div className="min-h-screen flex flex-col bg-dark-900">
      <Navbar />
      <main className="flex-grow pt-32 pb-20 px-6 relative">
        {/* Ambient background glow */}
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-900/5 rounded-full blur-[120px] pointer-events-none" />
        
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="mb-12">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
              <div>
                <GlowText as="h1" className="text-5xl md:text-7xl text-white mb-6"> 
                  News 
                </GlowText>
                <p className="text-xl text-gray-400 max-w-2xl font-light"> 
                  Live news feed used for research and situational awareness. 
                </p>
              </div>

              {/* Refresh Section */}
              <motion.div 
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                className="flex flex-col items-start md:items-end gap-3"
              >
                <p className="text-xs text-gray-500 max-w-[240px] md:text-right leading-relaxed">
                  Refreshes the news feeds. This action is required to ensure you are seeing the latest news feeds and most recent updates.
                </p>
                <a 
                  href="https://claritynchaos.com/newsapp/api/news_refresh.php" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-2.5 rounded-full bg-cyan-500/10 border border-cyan-500/30 text-cyan-400 hover:bg-cyan-500/20 hover:border-cyan-500/50 transition-all duration-300 flex items-center gap-2 text-sm font-medium group"
                >
                  <FiRefreshCw className="text-xs group-hover:rotate-180 transition-transform duration-500" />
                  <span>News Refresh</span>
                </a>
              </motion.div>
            </div>
          </div>

          {/* Iframe Container */}
          <motion.div 
            initial={{opacity: 0,y: 20}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 0.6,delay: 0.2}} 
            className="relative w-full rounded-xl overflow-hidden border border-white/10 bg-black shadow-2xl" 
          >
            <iframe src="/newsapp/news-search/" className="w-full h-[75vh] md:h-[85vh] border-none" title="News Search Feed" />
          </motion.div>

          {/* Full View Link */}
          <div className="mt-8 flex justify-end">
            <a href="/newsapp/news-search/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-sm font-medium text-gray-400 hover:text-cyan-400 transition-colors group" >
              <span>Open in full view</span>
              <FiExternalLink className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default News;